module.exports = "/build/images/RedButton.svg?20bd403c9d250009fe6e369e9f60d17c";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/RedButton.svg
// module id = 2416
// module chunks = 0